import * as React from "react";
import { PageHeader, Wrapper } from "components";
import { useNavigate, useToast } from "duck";
import { useCreateLicenseMutation } from "requests";
import Form from "../form";

const Create: React.FC = () => {
  const toast = useToast({ status: "success" });
  const navigate = useNavigate();
  const [create] = useCreateLicenseMutation({ ignoreResults: true });

  return (
    <>
      <PageHeader title="Create License" backURL={-1} />
      <Wrapper my={6}>
        <Form
          onSubmit={({ status, ...values }) =>
            create({
              variables: {
                input: {
                  ...(values as any),
                  active: status === "true"
                }
              }
            }).then(() => {
              toast({ description: "License is created successfully." });
              navigate("/license-management");
            })
          }
        />
      </Wrapper>
    </>
  );
};

export default Create;
